import { useEffect, useState } from "react";
import { Stack, Checkbox, Select, MenuItem, InputLabel, FormControl, SelectChangeEvent, FormControlLabel } from "@mui/material";

import styles from "./GPT4VSettings.module.css";
import { GPT4VInput } from "../../api";

interface Props {
    gpt4vInputs: GPT4VInput;
    isUseGPT4V: boolean;
    updateGPT4VInputs: (input: GPT4VInput) => void;
    updateUseGPT4V: (useGPT4V: boolean) => void;
}

export const GPT4VSettings = ({ updateGPT4VInputs, updateUseGPT4V, isUseGPT4V, gpt4vInputs }: Props) => {
    const [useGPT4V, setUseGPT4V] = useState<boolean>(isUseGPT4V);
    const [vectorFieldOption, setVectorFieldOption] = useState<GPT4VInput>(gpt4vInputs || GPT4VInput.TextAndImages);

    const onuseGPT4V = (_ev?: React.FormEvent<HTMLElement | HTMLInputElement>, checked?: boolean) => {
        updateUseGPT4V(!!checked);
        setUseGPT4V(!!checked);
    };

    const onSetGPT4VInput = (event: SelectChangeEvent<GPT4VInput>) => {
        const value = event.target.value as GPT4VInput;
        updateGPT4VInputs(value || GPT4VInput.TextAndImages);
        setVectorFieldOption(value);
    };

    useEffect(() => {
        useGPT4V && updateGPT4VInputs(GPT4VInput.TextAndImages);
    }, [useGPT4V]);

    return (
        <Stack className={styles.container} spacing={1.25}>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={useGPT4V}
                        onChange={onuseGPT4V}
                    />
                }
                label="Use GPT-4 Turbo with Vision Inputs"
            />
            {useGPT4V && (
                <FormControl
                    required
                    className={styles.oneshotSettingsSeparator}
                    fullWidth
                >
                    <InputLabel id="gpt4v-input-label">GPT-4 Turbo with Vision Inputs</InputLabel>
                    <Select
                        labelId="gpt4v-input-label"
                        value={vectorFieldOption}
                        label="GPT-4 Turbo with Vision Inputs"
                        onChange={onSetGPT4VInput}
                    >
                        <MenuItem value={GPT4VInput.TextAndImages}>Images and text from index</MenuItem>
                        <MenuItem value={GPT4VInput.Images}>Images only</MenuItem>
                        <MenuItem value={GPT4VInput.Texts}>Text only</MenuItem>
                    </Select>
                </FormControl>
            )}
        </Stack>
    );
};